const FIELD_LABEL_MAP = {
  category: "Store Group",
  postcode: "Zip Code",
};

const humanize = (segment) => {
  if (!segment) return "";
  return segment
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

const labelFromPath = (path) => {
  if (!path) return "Field";
  const tail = path.split("/").filter(Boolean).pop();
  return FIELD_LABEL_MAP[tail] || humanize(tail) || "Field";
};

const messageFor = (error) => {
  const { keyword, instancePath = "", params = {}, message } = error;

  if (keyword === "required") {
    const prop = params.missingProperty;
    const reqLabel = FIELD_LABEL_MAP[prop] || humanize(prop) || "Field";
    return `${reqLabel} is required`;
  }

  const label = labelFromPath(instancePath);

  switch (keyword) {
    case "minLength":
      return params.limit === 1
        ? `${label} is required`
        : `${label} must have at least ${params.limit} characters`;
    case "pattern":
      return `${label} format is invalid`;
    case "minimum":
      return `${label} must be at least ${params.limit}`;
    case "maximum":
      return `${label} must be at most ${params.limit}`;
    case "minItems":
      return `${label} must have at least ${params.limit} item${
        params.limit === 1 ? "" : "s"
      }`;
    case "type":
      return `${label} must be a ${params.type}`;
    case "enum":
      return `${label} must be one of the allowed values`;
    case "anyOf":
      return error.parentSchema?.message
        ? `${label}: ${error.parentSchema.message}`
        : `${label} is invalid`;
    default:
      return message ? `${label} ${message}` : `${label} is invalid`;
  }
};

export const formatValidationErrors = (errors = []) => {
  const seen = new Set();
  const result = [];
  for (const error of errors) {
    if (!error) continue;
    if (error.schemaPath && error.schemaPath.includes("/anyOf/")) continue;
    const text = messageFor(error);
    if (seen.has(text)) continue;
    seen.add(text);
    result.push(text);
  }
  return result;
};
